import st from "@/styles/Ui.module.scss"
import TextField from "@/ui/TextField.tsx";
import React, {useEffect, useRef, useState} from "react";
import clsx from "clsx";
import {pin_value} from "@/atoms/common.ts";
import {useAtom} from "jotai";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";


interface Props {
    className?: string
    onChange?(): void
    error?:boolean
}

const WritePinFields:React.FC<Props> = ({className, onChange, error}) => {
    
    const effect_ran = useRef<boolean>(false)
    const [pin, setPin] = useAtom(pin_value);
    const [err_text, set_err_text] = useState<string>("")
    
    const maxLength = 1
    const id_root = `input_pin_`
    
    const err_text_handle = (x:string) => {
        set_err_text(x)
    }
    
    const keydown = (e:any) => {
        
        let newPin = [...pin];
        
        let id = Number(e.target.id[e.target.id.length - 1])
        const current:any = document.getElementById(`${id_root}${id}`)
        
        let prev_id = Number(e.target.id[e.target.id.length - 1]) - 1
        const prev_input:any = document.getElementById(`${id_root}${prev_id}`)
        
        let next_id = Number(e.target.id[e.target.id.length - 1]) + 1
        const next_input:any = document.getElementById(`${id_root}${next_id}`)
        
        if (/^\d$/.test(e.key)) {
            newPin[id] = e.key;
            
            if(next_input) {
                next_input.focus()
            }
            
        }
        
        if(e.key === "Backspace") {

            if(current.value.length) {
                newPin[id] = ""
            } else {
                newPin[prev_id] = ""

                if(prev_input) {
                    e.preventDefault()
                    prev_input.focus()
                }
            }
        }
        
        if(e.key === " " || e.key === "ArrowRight") {
            
            if(next_input) {
                next_input.focus()
            }
        }
        
        if(e.key === "ArrowLeft") {
            if(prev_input) {
                prev_input.focus()
            }
        }
        
        setPin(newPin);
    }
    
    const resetPin = () => {
        const first_input = document.getElementById(`${id_root}0`)
        
        if(first_input) {
            first_input.focus()
        }
        
        setPin(['', '', '', ''])
    }
    

    const onPasteHandler = (e:any) => {
        const clipboardData = e.clipboardData;
        const pastedText = clipboardData.getData('text');
        
        let arr:Array<string> = []
        
        if(pastedText.length === 4) {
            pastedText.split("").map((t:string) => {
                if(Number(t) || t === "0") {
                    arr.push(t)
                }
            })
            
            if(arr.length === 4) {
                
                arr.map((str, i) => {
                    let elem = document.getElementById(`${id_root}${i}`)
                    
                    if(elem) {
                        (elem as HTMLInputElement).value = str
                    }
                    
                })
                
                setPin(arr)

            }
        }
    }


    useEffect(() => {
        const first_input = document.getElementById(`${id_root}0`)
        eventEmitter.on(CommonClass.CustomEvents.set_pin_err_text, err_text_handle)
        if(first_input) {
            first_input.focus()
        }
        
        if(!effect_ran.current) {
            eventEmitter.on(CommonClass.CustomEvents.reset_otp_value, resetPin)
        }
        
        return () => {
            effect_ran.current = true
            eventEmitter.off(CommonClass.CustomEvents.set_pin_err_text, err_text_handle)
            if(!effect_ran.current) {
                eventEmitter.off(CommonClass.CustomEvents.reset_otp_value, resetPin)
            }
        }

    }, []);
    
    return (
        <div className={clsx(st.pin_fields, className && className)}>
            <div className={st.fields}>
                {pin.map((digit:any, index:number) => {
                    return (
                        <TextField
                            error={error && error}
                            key={index}
                            name={`pin${index}`}
                            type={"tel"}
                            value={digit}
                            handleKeyDown={(e:any) => keydown(e)}
                            inputMode={"numeric"}
                            onChange={(_e:any) => {
                                // if(Number(e.target.value) || e.target.value === "" || e.target.value === "0") {
                                //     handleChange(index, e.target.value)
                                // }
                                if(typeof onChange === "function") {
                                    onChange()
                                }
                            }}
                            maxLength={maxLength}
                            className={st.inputs}
                            id={`${id_root}${index}`}
                            onPaste={onPasteHandler}
                        />
                    )
                })}
            </div>
            
            {err_text.length ? (
                <span className={st.err_text}>{err_text}</span>
            ) : null}
            
            {/*{error && (*/}
            {/*    <span className={st.error_span}>*/}
            {/*        {t("incorrect_code")}*/}
            {/*    </span>*/}
            {/*)}*/}
        </div>
    );
}

export default WritePinFields